import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * A name with an optional lead (dot), inline badges and a muted subline, on one line.
 * Grid, not flex: the first track takes the name's full max-content width before the
 * 1fr subline gets anything, so a name that fits never loses a fraction of a pixel to
 * an ellipsis; it truncates only when it alone is too long. The subline gives way first.
 */
export function NameCell({ lead, name, after, sub, title, nameClassName }: {
  lead?: ReactNode;
  name: string;
  after?: ReactNode;
  sub?: ReactNode;
  title?: string;
  nameClassName?: string;
}) {
  return (
    <span className="flex items-center min-w-0" title={title ?? name}>
      {lead && <span className="shrink-0 flex items-center">{lead}</span>}
      <span className="grid grid-cols-[minmax(0,max-content)_minmax(0,1fr)] items-center min-w-0 flex-1">
        <span className="flex items-center gap-1.5 min-w-0">
          <span className={cn("truncate min-w-0", nameClassName)}>{name}</span>
          {after && <span className="shrink-0 flex items-center gap-1">{after}</span>}
        </span>
        {sub ? <span className="ml-1.5 truncate min-w-0 text-xs text-muted-foreground">{sub}</span> : <span />}
      </span>
    </span>
  );
}
